module.exports = __webpack_public_path__ + "img/vulcans-tf-2.1a4c51a.jpg";